import {
  calculateProgressbar,
  trigger_err,
  trigger_percentreward,
  trigger_success,
  validate,
} from '../../components/triggers_and_progressbar'
import {
  disableOptionalField,
  enableOptionalField, GetURLParameter,
  pushGTMEvent,
} from '../../components/helpers'

function initIBANHandler (country) {
  if (country.is_ES) {
    let ibanSwitcher = function (mainSelector, label, hideSelector, mask, placeholder, callback) {
      $(mainSelector).on('click', function () {
        $(this).closest('div').addClass('hidden').closest('.ui-form__row').find('.ui-input__label_placeholder-text').text(label)
        $(hideSelector).closest('div').removeClass('hidden')
        // set IBAN ES handler
        let first_iban_touch = true
        let selector = $('[name=bank_account_number]')
        selector.inputmask('remove')
        selector.on('keyup', function () {
          if (first_iban_touch && $(mainSelector).closest('div').hasClass('hidden')) {
            selector.inputmask(mask, {
              showMaskOnHover: false
            });
            first_iban_touch = false
          }
        })
        selector.attr('placeholder', placeholder)
        callback(selector)
      })
    }

    ibanSwitcher('#IBANToCCC', 'Número de cuenta', '#CCCToIBAN', '99999999999999999999', 'Número de cuenta', function (selector) {
      let val = selector.val().split(' ').join('')
      if (val.length === 24 && val.indexOf('_') === -1) {
        selector.val(val.slice(4, val.length))
      } else {
        selector.val('')
      }
    })
    ibanSwitcher('#CCCToIBAN', 'Cuenta Bancaria (IBAN)', '#IBANToCCC', fields_json.params.iban.mask, 'ES ** **** **** ** **********', function (selector) {
      if (selector.val().length === 20 && selector.val().indexOf('_') === -1) {
        selector.val(CCCToIBAN(selector.val(),'ES'))
      } else {
        selector.val('ES')
      }
    })
    // first init
    $('#CCCToIBAN').trigger('click')

    var $hint = $('[name=bank_account_number]').closest('.ui-form__field').find('#hint')
    $hint.css('display', 'none'); // Hide the hint
    $('[name=bank_account_number]').on('input', function (e) {
      var ibanValue = e.target.value.split(' ').join('')
      if (ibanValue.length === 24 && ibanValue.slice(4,8) === '2038') {
        $hint.fadeIn(150)
      } else {
        $hint.fadeOut(150)
      }
    })
  }
}

function initLoanSumSlider () {
  $('[name=loan_sum]').on('keyup blur', function (e) {
    var inpVal = $('[name=loan_sum]').val()
    var slVal = $('#loan_sum_range').val()
    if (inpVal != slVal && inpVal) $('#loan_sum_range').val(+$(this).val().split(window.override_sum_separator || ' ').join(''))
    if (!inpVal && e.type != 'keyup') $(this).val(slVal)
    setTimeout(function () { changeColor('#loan_sum_range') }, 100)
  })

  $('#loan_sum_range').on('input', function () {
    if ($(this).val() != $('[name=loan_sum]').val()) $('[name=loan_sum]').val($(this).val())
    changeColor('#loan_sum_range')
  })

  function changeColor(id) {
    var el = $(id)
    var x = ((el.val() - el.attr('min') / 1) * 100) / (el.attr('max') / 1 - el.attr('min') / 1);
    var color = "linear-gradient(90deg, " + $('button[type=submit]').css('background-color') + " " + x + "%, #eee " + x + "%)";
    el.css('background', color)
  }

  // for iOS click polyfill
  var last_loan_sum = $('#loan_sum_range').val()
  $('#loan_sum_range').on('click', function (e) {
    var min = parseInt(e.target.min);
    var max = parseInt(e.target.max);
    var val = (((e.offsetX + ((e.offsetX > e.target.clientWidth / 2) ? 10 : -10)) / (e.target.clientWidth)) * (max - min) + min)
    if (last_loan_sum == $(this).val()) $(this).val(Math.round(val)).trigger('input')
    last_loan_sum = $(this).val()
  })

  // trick for autocomplete loan sum and period
  setTimeout(function () {
    if (!$('[name=loan_sum]').val()) {
      $('[name=loan_sum]').val(1).focus()
      $('#loan_sum_range').val(1)
      changeColor('#loan_sum_range')
      setTimeout(function () { $('[name=loan_sum]').blur() }, 100)
    }
    if (!$('[name=loan_period]').val()) {
      $('[name=loan_period]').val(fields_json.params.loan_period.default || 1).focus().blur()
      setTimeout(function () { $('[name=loan_period]').focus().blur() }, 100)
    }

  }, 1000)
}

function CCCToIBAN (ncuenta, cpais) {
  if (cpais.length != 2)
    return "";
  else {
    let backup = ncuenta
    let aux
    let csiguientes
    let tmp
    ncuenta = ncuenta + (cpais.charCodeAt(0) - 55).toString() + (cpais.charCodeAt(1) - 55).toString() + "00";
    tmp = parseInt(ncuenta.substring(0, 9), 10) % 97;
    if (tmp < 10)
      aux = "0";
    else
      aux = "";
    aux = aux + tmp.toString();
    ncuenta = ncuenta.substring(9);
    while (ncuenta != "") {
      if (parseInt(aux, 10) < 10)
        csiguientes = 8;
      else
        csiguientes = 7;
      if (ncuenta.length < csiguientes) {
        aux = aux + ncuenta;
        ncuenta = "";
      } else {
        aux = aux + ncuenta.substring(0, csiguientes);
        ncuenta = ncuenta.substring(csiguientes);
      }
      tmp = parseInt(aux, 10) % 97;
      if (tmp < 10)
        aux = "0";
      else
        aux = "";
      aux = aux + tmp.toString();
    }
    tmp = 98 - parseInt(aux, 10);
    if (tmp < 10)
      return cpais + "0" + tmp.toString() + backup;
    else
      return cpais + tmp.toString() + backup;
  }
}

function radioHandlers () {
  $('[type=radio]').on('change', function () {
    var name = $(this).attr('name');
    if ($(this).prop('checked')) {
      trigger_success($(this).closest('.ui-form__field'))
      $(this).closest('.radio').addClass('checked');
      $('[name=' + name + ']').not($(this)).closest('.radio').removeClass('checked');
      if (name == "has_other_loans" && country.is_MX) {
        if (+$(this).val()) {
          enableOptionalField('other_loans_amount')
          enableOptionalField('other_loans_company')
        } else {
          disableOptionalField('other_loans_amount')
          disableOptionalField('other_loans_company')
        }
      }
      if (name == "has_other_loans" && (country.is_ES || country.is_CO)) {
        if (+$(this).val()) {
          enableOptionalField('other_loans_amount')
        } else {
          disableOptionalField('other_loans_amount')
        }
      }
      if (name == "has_car") {
        if (+$(this).val()) {
          for (let i in carFieldsHardcore) enableOptionalField(carFieldsHardcore[i])
        } else {
          for (let i in carFieldsHardcore) disableOptionalField(carFieldsHardcore[i])
        }
      }
      if (name == "has_bank_online" && country.is_MX) {
        if (+$(this).val() && step_required_fields.indexOf('bank_account_number') > -1) {
          $("[name=bank_account_number]").closest('.ui-form__row').removeClass('hidden')
          $("[name=bank_account_number]").val("")
        } else {
          $("[name=bank_account_number]").closest('.ui-form__row').addClass('hidden')
          $("[name=bank_account_number]").val("IGNORE")
          pushGTMEvent({
            'event': 'hasDeclinedIBAN'
          })
        }
      }
      if (name === 'has_bank_online' && (country.is_PH || country.is_VN)) {
        let value
        if (country.is_PH) value = 'Other'
        if (country.is_VN) value = 'Lí do khác'
        $('[name=loan_purpose]').val(value)
      }
      if (name === "gender") localStorage.setItem('gender', +$(this).val())
    } else {
      $(this).closest('.radio').removeClass('checked');
    }
  })
}

function emailHandlers () {
  $('[name=email]').on('keyup', function (e) {
    if ($('[name=email_repeat]').length) {
      validate($('[name=email_repeat]'))
    }
  })

  var $hint = $('[name=email]').closest('.ui-form__field').find('#hint')
  $hint.css('display', 'none'); // Hide the hint
  $('[name=email]').on('keyup', function (e) {
    var temp = $('[name=email]').val().split('@')
    if (temp.length > 1) {
      if (temp[1] == 'mail.com') {
        var suggestion = fields_json.params.for_fields.email_hint + "<span class='suggestion'>" +
          "<span class='address'>" + temp[0] + "</span>"
          + "@<a id='unique-a' class='domain' style='cursor: pointer'>" + "gmail.com" +
          "</a></span>?";
        $hint.html(suggestion).fadeIn(150);
        $('#unique-a').on('click', function () {
          $('[name=email]').val($(".suggestion").text());
          trigger_success($('[name=email]').closest('.ui-form__field'));
          $hint.fadeOut(200, function () {
            $(this).empty();
          });
        });
      } else {
        $hint.fadeOut(200, function () {
          $(this).empty();
        });
      }
    } else {
      $hint.fadeOut(200, function () {
        $(this).empty();
      });
    }
  });
  var old_email = '';
  $('[name=email]').keydown(function (e) {
    old_email = $('[name=email]').val()
    return true;
  }).on('input', function (e) {
    var newValue = e.target.value
    var splited = newValue.split('@')
    if (splited.length > 1) {
      var regex = new RegExp("^[a-zA-Z.-]+$");
      if (regex.test(splited[1])) {
        return true;
      } else if (splited[1] == '') {
        return true;
      }
    } else {
      return true
    }
    $('[name=email]').val(old_email)
  })
}

function phoneHandlers () {
  let phoneForConfirm = function (phone) {
    $('[name=confirm]').closest('.ui-form__row').prev('.field_label-text').find('.phone-number').text(phone);
  }
  $('[name=phone]').on('keyup', function () {
    if ($(this).inputmask('isComplete')) {
      $(this).closest('.ui-form__row').next('.ui-form__row').find('input').focus();
    }
  }).on('blur', function () {
    phoneForConfirm($(this).val())
  })
  $('[name=ar-phone], [name=ar-phone-code]').on('blur', function () {
    phoneForConfirm($('[name=ar-phone-code]').val() + ' ' + $('[name=ar-phone]').val())
  })

  // Phone mask
  // var first_phone_touch = true;
  // $('input[name=phone], input[name=reference_phone], input[name=work_phone]').on('keyup', function (e) {
  //   if (e.key != 'Tab' && e.key != 'Backspace' && first_phone_touch) {
  //     $(this).inputmask(fields_json.params.phone.mask, {
  //       positionCaretOnClick: "radixFocus",
  //       showMaskOnHover: false,
  //       showMaskOnFocus: false,
  //     });
  //     first_phone_touch = false
  //   }
  // }).on('focus', function () {
  //   if ($(this).val() == '') $(this).inputmask('remove').val('').val(fields_json.params.phone.val);
  //   if ($(this).val() == fields_json.params.phone.mask.val) $(this).val('').val(fields_json.params.phone.val);
  //   $(this)[0].setSelectionRange($(this).val().length, $(this).val().length);
  // }).on('blur', function () {
  //   if ($(this).val() == '' || $(this).val() == fields_json.params.phone.placeholder) setTimeout(function () {
  //     $(this).inputmask('remove').val('');
  //   }, 5);
  //   first_phone_touch = true
  // }).on('paste', function () {
  //   $(this).val('');
  // });
  $('input[name=phone], input[name=reference_phone], input[name=work_phone]').inputmask(fields_json.params.phone.mask, {
    positionCaretOnClick: "radixFocus",
    showMaskOnHover: false
  })
}

function dateHandlers () {
  // Set up birthday mask field
  $('[name=birthday], [name=work_start_date]').inputmask({
    mask: "99/99/9999",
    placeholder: "__/__/____",
    separator: "/",
    alias: "**/**/****",
    showMaskOnHover: false,
    showMaskOnFocus: false
  });
}

function otherHandlers () {
  // Trigger change on page start
  $('input').not('[type=radio]').on('focus', function () {
    $(this).closest('.ui-input').addClass('ui-input_focused ui-dropdown-field__active ui-dropdown-field__active_focused');
    $(this).closest('.ui-input__container').addClass('ui-input__container_focused');
    trigger_percentreward($(this));
  }).on('blur', function () {
    $(this).closest('.ui-input').removeClass('ui-input_focused ui-dropdown-field__active ui-dropdown-field__active_focused');
    $(this).closest('.ui-input__container').removeClass('ui-input__container_focused');
    trigger_percentreward(false);
    if ($(this).val().length > 0) {
      $(this).addClass('ui-input__field_not-empty');
    } else {
      $(this).removeClass('ui-input__field_not-empty');
    }
  });
  // Window trigger
  $('.modal .close').click(function (e) {
    e.preventDefault();
    $(this).closest('.modal').removeClass('in');
    $('html').removeClass('locked');
  })
  $('[type=checkbox]').on('change', function () {
    if ($(this).prop('checked')) {
      $(this).closest('.ui-checkbox-directive').find('label').addClass('ui-checkbox_checked');
      trigger_success($(this).closest('.ui-form__field'));
    } else {
      $(this).closest('.ui-checkbox-directive').find('label').removeClass('ui-checkbox_checked');
      trigger_err($(this).closest('.ui-form__field'));
    }
  })
  $(document).on('click', '.cancel_inputing', function () {
    $(this).closest('.ui-input').find('.ui-input__field').val('').removeClass('ui-input__field_not-empty');
  })
  $('[data-required]').on('blur keyup', function () {
    validate($(this));
  });

  if (country.is_VN || country.is_AR || window.override_sum_separator) {
    $('[name=loan_sum]').inputmask('decimal', {
      autoGroup: true,
      digits: 2,
      integerDigits: 13,
      radixPoint: "/",
      groupSeparator: window.override_sum_separator || " ",
      groupSize: 3,
      skipRadixDance: true
    });
  } else {
    $('[name=loan_sum]').inputmask("numeric", fields_json.params.loan_sum)
  }
  if (country.is_AR) $('[name=cuit]').inputmask({mask: '99-99999999-9', showMaskOnHover: false, showMaskOnFocus: false})
  $('[name=loan_period]').inputmask('numeric', fields_json.params.loan_period);
  $('[name=loan_sum]').on('blur', function () {
    var summ = parseInt($(this).val().split(window.override_sum_separator || ' ').join(''));
    var summCeil = Math.ceil(summ / fields_json.params.loan_sum.step) * fields_json.params.loan_sum.step
    if (summ < fields_json.params.loan_sum.max && summ % fields_json.params.loan_sum.step !== 0 && summ > fields_json.params.loan_sum.min) {
      summ = summCeil
    } else if (summ > fields_json.params.loan_sum.max) {
      summ = fields_json.params.loan_sum.max
    } else if (summ < fields_json.params.loan_sum.min) {
      summ = fields_json.params.loan_sum.min
    }
    $(this).val(summ)
    $('#loan_sum_range').val(summ)
  });
  $('[name=loan_sum],#loan_sum_range').on('change click', function () {
    localStorage.setItem('amount', $(this).val())
    calculateProgressbar()
  })
}

export { initIBANHandler, initLoanSumSlider, CCCToIBAN, radioHandlers, emailHandlers, phoneHandlers, dateHandlers, otherHandlers }